export default function PageBannerSkeletonContent() {
  return (
    <div className="animate-pulse">
      {/* Breadcrumb */}
      <div className="flex gap-2 mb-3">
        <div className="h-3 w-20 bg-white/40 rounded" />
        <div className="h-3 w-3 bg-white/40 rounded" />
        <div className="h-3 w-24 bg-white/40 rounded" />
      </div>

      {/* Title */}
      <div className="h-8 w-1/3 bg-white/80 rounded mb-4" />

      {/* Description */}
      <div className="space-y-3 w-10/12 lg:w-1/2">
        <div className="h-4 w-full bg-white/60 rounded" />
        <div className="h-4 w-10/12 bg-white/60 rounded" />
        <div className="h-4 w-8/12 bg-white/60 rounded" />
      </div>
    </div>
  );
}
